import React, { useEffect, useRef, useState } from "react";
import "../styles/caseStudyGallery.css";
import { useDispatch, useSelector } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useMediaQuery } from "react-responsive";
import { GoVideo } from "react-icons/go";
import { BiCheckbox, BiSolidCheckbox } from "react-icons/bi";
import { IoAddSharp } from "react-icons/io5";
import loader from "../assets/img/loader/loader1.jpg";
import { getProjects } from "../features/project/projectSlice";

export default function CaseStudyGallery() {
  const dispatch = useDispatch();
  const servicesRef = useRef(null);
  const isDesktop = useMediaQuery({ minWidth: 768 });

  const { projects } = useSelector((state) => state.project);
  const [videoLoaded, setVideoLoaded] = useState({});
  console.log(projects,"projects")
  const videoProps = isDesktop
    ? {
        onMouseEnter: (e) => {
          const video = e.currentTarget;
          if (video.paused) video.play().catch(() => {});
        },
        onMouseLeave: (e) => {
          const video = e.currentTarget;
          if (!video.paused) {
            video.pause();
            video.currentTime = 0;
          }
        },
      }
    : {
        autoPlay: true,
        muted: true,
        playsInline: true,
      };

  useEffect(() => {
    dispatch(getProjects());
  }, [dispatch]);

  useEffect(() => {
    if (!servicesRef.current) return;

    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");

    const scrollReveal = () => {
      revealElements.forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight / 1.15) {
          el.classList.add("revealed");
        } else {
          el.classList.remove("revealed");
        }
      });
    };

    window.addEventListener("scroll", scrollReveal);
    scrollReveal();

    return () => window.removeEventListener("scroll", scrollReveal);
  }, [projects]);

  const handleVideoLoaded = (key) => {
    setVideoLoaded((prev) => ({ ...prev, [key]: true }));
  };

  const featuredProjects =
    projects
      ?.filter((project) => project.tag === "Featured")
      ?.slice(0, 4) || [];

  return (
    <div className="case-study-wrap">
      <div className="case__study-header">
        <h1>Featured Projects</h1>
        <div className="hr__container">
          <div>
            <BiCheckbox />
            <BiSolidCheckbox />
            <BiSolidCheckbox />
          </div>
          <hr />
          <IoAddSharp />
        </div>
      </div>

      <div className="case-study-inner" ref={servicesRef}>
        {featuredProjects.map((item, index) => {
          const isVideo = item.type === "video";
          const mediaUrl = isVideo ? item.video?.url : item.images?.[0]?.url;

          return (
            <div className="card" data-reveal key={item._id || index}>
              <div className={`media ${item.mediaClass || ""}`}>
                {isVideo ? (
                  <>
                    {!videoLoaded[item.title] && (
                      <img
                        src={loader}
                        alt="loading"
                        className="video-placeholder"
                      />
                    )}

                    <video
                      key={item.title}
                      loop
                      muted
                      playsInline
                      preload="metadata"
                      onLoadedData={() => handleVideoLoaded(item.title)}
                      {...videoProps}
                      style={{ opacity: videoLoaded[item.title] ? 1 : 0 }}
                    >
                      <source src={mediaUrl} type="video/mp4" />
                    </video>

                    <div className="roarz__watermark">
                      <GoVideo />
                    </div>
                  </>
                ) : (
                  <LazyLoadImage
                    key={item.title}
                    src={mediaUrl}
                    alt={item.title}
                    effect="blur"
                    placeholderSrc={loader}
                    width="100%"
                    height="100%"
                  />
                )}
              </div>

              <div className="meta">
                <h3 data-reveal="left">
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    {item.title}
                  </a>
                </h3>

                <div className="tags" data-reveal>
                  {item.categories?.slice(0, 3).map((tag, idx) => (
                    <span key={idx}>{tag.toUpperCase()}</span>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="view__more-btn">
        <a href="/recent-work">View More</a>
      </div>
    </div>
  );
}